function is_mobile_validated(number) {
  return /[0۰][0-9۰-۹]{10}/.test(number);
}

export default is_mobile_validated;
